let currentProgramBuilder;
/** @internal */ function setCurrentProgramBuilder(pb) {
    currentProgramBuilder = pb;
}
/** @internal */ function getCurrentProgramBuilder() {
    return currentProgramBuilder;
}

export { getCurrentProgramBuilder, setCurrentProgramBuilder };
//# sourceMappingURL=misc.js.map
